import {
  Component,
} from "react";
import store from "CommonState/store";
import {
  matchPath,
} from "react-router";

import LoginPage from "App/login-page";
import DashboardPage from "App/dashboard-page";
import ResetPage from "App/pwd-reset-page";
import {
  inline,
} from "CommonState/action-helpers";
import DatenschutzPage from "App/datenschutz-page";
import {
  renderChildren, flatAppPaths, withLocation,
} from "CommonCore/router-util";

import _ from "lodash";

@store("user", "locationParams")
@withLocation
export default class App extends Component {
  locationToParams(currentLocation) {
    // const result = matchPath(currentLocation, { path: flatAppPaths, exact: true }); // react router 5
    let params = {};
    for (const p of flatAppPaths) {
      const result = matchPath({ path: p, exact: true }, currentLocation); // für react router 6
      if (result) {
        params = result.params;
        break;
      }
    }

    return params;

    /*
     *const result = matchPath({ path: flatAppPaths, exact: true }, currentLocation); // für react router 6
     *if (result) {
     *  return result.params;
     *}
     */
    // else return {};
  }

  componentDidMount() {
    setTimeout(() => {
      this.props.dispatch(inline("locationParams", state => {
        const params = this.locationToParams(this.props.location.pathname);
        state.locationParams = params;
      }));
    }, 0);
  }

  componentDidUpdate(prevProps) {
    const { dispatch } = this.props;
    const params = this.locationToParams(this.props.location.pathname);
    const prevParams = this.locationToParams(prevProps.location.pathname);

    if (!_.isEqual(prevParams, params)) {
      setTimeout(() => {
        dispatch(inline("locationParams", state => {
          state.locationParams = params;
        }));
      });
    }
  }

  render() {
    const { user, location } = this.props;

    if (!user && location.pathname == "/datenschutz") {
      return <div>
        <div id='wrapper' style={{ padding: "20px" }}> <DatenschutzPage mitHeader /></div>
      </div>;
    }
    return !user
? location.pathname == "/pwvergessen" ? <ResetPage location={location} /> : <LoginPage />
        : <DashboardPage location={location}>
          {renderChildren(this.props)}
        </DashboardPage>;
  }
}
